<template>
    <div>
        <Header title="客户池">
            <template v-slot:content>
                <div style="display: flex">
                    <div style="flex:1">
                        <Input prefix="ios-search" v-model="search_name" placeholder="请输入用户姓名"  style="width:240px;"></Input>
                        <div class="screen-tags" @click="screenTags">
                            <span v-if="!screen_tags_text">筛选标签</span>
                            <div v-else class="screen-tags-text" >
                                {{screen_tags_text}}
                            </div>
                            <Icon v-if="screen_tags_text" @click.stop="cleanTags" size="20" class="screen-tags-icon"  type="ios-close-circle" />
<!--                            <Icon @click="cleanTags" size="20" class="screen-tags-icon" type="ios-close-circle-outline" />-->

                        </div>
                        <Select   v-if="userInfo.role == 0" style="width:165px;margin-left:10px" placeholder="请选择销售人员"  v-model="search_sale_id" clearable  filterable >
                            <Option v-for="(item, index) in department_member_list" :value="item.id" :key="index">{{item.platform_name}}-{{ item.name }}</Option>
                        </Select>
                        <Button  @click="searchList" type="warning"  style="margin-left:10px">搜索</Button>
                    </div>
                    <div>
<!--                        <Button @click="sync_customer">同步</Button>-->
                        <Button @click="show_customer_fun" style="margin-left:10px" type="primary">新增</Button>
                    </div>

                </div>
            </template>
        </Header>
        <div class="my-white-mod">
            <PageTable  :loading="table.loading"  :size="table.limit" :columns="table.columns" :data="table.data" :current="table.current" :total="table.total" @switchPage="changepage"  >
            </PageTable>
        </div>


        <Modal
                v-model="show_industry"
                title="行业选择"
                width="400"
                :mask-closable="false"
        >
            <div class="modal-title">选择行业</div>
            <Select placeholder="请选择行业" filterable v-model="industry_id">
                <Option v-for="item in industry_list" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <div slot="footer">
                <Button  type="primary"  @click="set_customer_industry">确定</Button >
            </div>
        </Modal>

        <Modal
                v-model="show_customer"
                title="客户列表"
                width="400"
                :mask-closable="false"
                id="add_customer"
        >
            <div class="modal-title">选择客户</div>
            <Select placeholder="请选择客户"
                    filterable
                    :remote-method="filter_customer"
                    :loading="customer_loading"
                    v-model="order_customer_id"
                    clearable
            >
                <Option v-for="item in order_customer_list" :value="item.id"   :key="item.id"  :label="item.name+'-'+item.remark">
                    <span>{{ item.name }}</span>
                    <span style="float:right;color:#ccc">{{item.remark}}</span>
                </Option>
            </Select>
            <div style="font-size:12px;margin-top:10px" @click="add_customer">若无客户，则点击<a>新建客户</a></div>
            <div slot="footer">
                <Button  type="primary"  @click="add_order">确定</Button >
            </div>
        </Modal>
        <Modal
                v-model="show_member"
                title="员工选择"
                width="400"
                :mask-closable="false"
        >
            <div class="modal-title">选择员工</div>
            <Select placeholder="请选择员工"  v-model="department_member_id" filterable >
                <Option v-for="item in department_member_list" :key="item.id" :value="item.id">{{ item.name }}</Option>
            </Select>
            <div slot="footer">
                <Button  type="primary"  @click="set_customer_staff">确定</Button >
            </div>
        </Modal>

        

        <DealShow ref="deal_child" :show_success.sync="show_success" :order_id="order_id" :customer_name="customer_name" :department_member_list="department_member_list"  :successSubmit="successSubmit" @submitSuccess="orderSubmitSuccess"></DealShow>
        <Modal
                v-model="show_release"
                title="释放"
                width="400"
                :mask-closable="false"
                @on-ok="relex_order"
        >
            <div class="my-modal-del">
                <Icon type="ios-alert"  />
                该客户将会被释放至公海
            </div>
        </Modal>

        <Modal
                v-model="show_follow"
                title="跟进记录"
                width="1000"
                :mask-closable="false"
        >
            <Button  style="margin-bottom:10px" @click="add_follow_fun" type="primary" >跟进</Button>

            <PageTable  :loading="follow_table.loading" :size="follow_table.limit" :columns="follow_table.columns" :data="follow_table.data" :current="follow_table.current" :total="follow_table.total" @switchPage="change_record"  >
            </PageTable>
            <div slot="footer"></div>
        </Modal>

        <Modal
                v-model="show_price"
                title="客户报价"
                width="400"
                :mask-closable="false"
        >
            <Input  placeholder="请填写客户报价" v-model="customer_price.price" />
            <div slot="footer">
                <Button  type="primary"  @click="surePrice">确定</Button >
            </div>
        </Modal>
        <!-- <Modal
                v-model="show_time"
                title="需求时间"
                width="400"
                :mask-closable="false"
                style="text-align:center"
        >       
                <div>客户需要系统的时间</div>
                <DatePicker  type="date" placeholder="选择日期" @on-change="changeDate"></DatePicker>
            <div slot="footer">
                <Button  type="primary"  @click="sureTime">确定</Button >
            </div>
        </Modal> -->
        <Modal
                v-model="show_add_follow"
                title="跟进记录"
                :mask-closable="false"
                width="600"
        >
            <div class="modal-title modal-title-two">跟进情况</div>
            <Input  v-model="formSuccess.note" type="textarea"  :rows="4" />
            <div class="modal-title modal-title-two">图片上传</div>
            <Upload multiple name="pic" :default-file-list="default_follow_img" :action="upload_url" :headers="{'authori-zation-crm':token}" :on-success="handleSuccess" :on-preview="handlePreview" :on-remove="handleRemove" >
                <Button icon="ios-cloud-upload-outline">选择图片</Button>
            </Upload>
            <div slot="footer">
                <Button  type="primary"  @click="edit_follow">确定</Button >
            </div>
        </Modal>
        <Modal
                :mask-closable="false"
                v-model="show_infos"
                title="客户资料"
                width="400"
        >
            <div class="modal-title"><span style="color:#ff0000">*</span>姓名</div>
            <Input  placeholder="请填写姓名"  v-model="submitInfo.name"  />
            <div class="modal-title modal-title-two">性别</div>
            <Select  placeholder="请选择性别" v-model="submitInfo.gender" >
                <Option v-for="item in genderArr" :value="item.id" :key="item.id">{{ item.name }}</Option>
            </Select>
            <div class="modal-title modal-title-two">手机号</div>
            <Input  placeholder="请填写手机号"  v-model="submitInfo.phone" />
            <div class="modal-title modal-title-two">微信昵称</div>
            <Input  placeholder="请填写微信号" v-model="submitInfo.wechat_number" />
            <div class="modal-title modal-title-two">旺旺号</div>
            <Input  placeholder="请填写旺旺号" v-model="submitInfo.wangwang_number"  />
            <div class="modal-title modal-title-two">邮箱</div>
            <Input  placeholder="请填写邮箱"  v-model="submitInfo.email" />
            <div class="modal-title modal-title-two">公司名称</div>
            <Input  placeholder="请填写公司名称"  v-model="submitInfo.company_name"  />
            <div class="modal-title modal-title-two">选择城市</div>
            <CitySelect v-if="show_infos" @select_city="select_city" :default_citys="submitInfo.city_number"></CitySelect>
            <div class="modal-title modal-title-two">详细地址</div>
            <Input  placeholder="请填写详细地址" v-model="submitInfo.detailed_address"  />
            <div slot="footer">
                <Button  type="primary"  @click="save_custmer">确定</Button >
            </div>
        </Modal>
        <Tags :customer_id="customer_id" :show_tags="show_label" :tags_active="tags_active" :is_return="tags_return" @return_data="get_select_tags" @hide_lable="hide_label_func"></Tags>
    </div>

</template>
<script>
    import {customer_industry_list, set_customer_industry,
        customer_department_member, set_customer_staff, get_customer_list, follow_record_list,
        follow_edit, del_img, save_customer_info, follow_del} from "@/api/customer"
    import {order_list, release_order, add_order, order_delete, order_locaking, order_topping, order_success, customerPrice, customerFunction} from "@/api/order"
    import {sync_customer} from "@/api/sync"
    import {Header, PageTable,Tags, CitySelect, DealShow} from "@/components/mainLayout"
    import config from '@/config';
    import WebSocket from '@/utils/websocket';
    import {getCookies, copyText, getCurrentDate} from "@/utils/helper";
export default {
    components:{
        Header,
        PageTable,
        Tags,
        CitySelect,
        DealShow,
    },
    data(){
        return{
            show_time:false,
            show_price:false,
            customer_function:{
                id:"",
                text:""
            },
            customer_price:{
                id:"",
                price:""
            },
            search_sale_id:"",
            tags_active:[],
            screen_tags_list:[],
            screen_tags_active:[],
            screen_tags_text:"",
            screen_tags_active_id:[],
            tags_return:false,
            customer_loading:false,
            show_infos:false,
            genderArr:[
                {id:1, name:'男'},
                {id:2, name:'女'}
            ],
            submitInfo:{},
            successSubmit:{
                customer_source_id:"",
                duesoon_type:'1',
                money:"",
                transaction_type_id:"",
                aftersale_id:"",
                service_requirements:"",
                servicecharge:"",
                qq_group:"",
                retainage:"",
                order_number:"",
                name:"",
                phone:"",
                wechat_number:"",
                wangwang_number:"",
                city_number:[],
                city_name:"",
                detailed_address:"",
                pay_time:"",
                remark:"",
                order_product_id:"",
                is_two_sale:0,
                latlng: "",
                is_big: "0",
            },

            default_follow_img:[],
            token:getCookies("token"),
            upload_url:config.uploadUrl,
            add_follow:false,
            customer_id:"",
            search_name:"",
            customer_name:"",
            order_id:0,
            needs_id:"",
            industry_id:"", 
            industry_list:[],
            department_member_id:"",
            department_member_list:[],
            order_customer_id:"",
            order_customer_list:[],
            show_follow:false,
            show_customer:false,
            show_label:false,
            show_industry:false,
            current_date:getCurrentDate(),
            show_needs:false,
            show_member:false,
            show_success:false,
            show_release:false,
            show_add_follow:false,
            formSuccess:{
                follow_img:[],
                note:""
            },
            userInfo:{},
            follow_table: {
                loading:false,
                current: 1,
                total: 0,
                limit: 30,
                columns: [
                    {
                        type:'index',
                        width:'80',
                        align:'center'
                    },{
                        title: '跟进时间',
                        align:'center',
                        width:'180',
                        key: 'follow_time'
                    },{
                        title: '状态',
                        align:'center',
                        key: 'id',
                        render: (h, params) => {
                            console.log(params.row)
                            let status_name = params.row.follow_type == 1 ? "首次跟进" : `第`+params.row.follow_type+`次跟进`;
                            return h('div', [
                                h('span', {}, status_name)
                            ]);

                        }
                    },{
                        title: '图片',
                        align:'center',
                        key: 'ctime',
                        render: (h, params) => {
                            let img_arr = [];
                            for (let i in params.row.follow_img) {
                                img_arr.push(params.row.follow_img[i].url)
                            }
                            if(img_arr.length > 0){
                                return h('div', img_arr.map(img=>{ //循环显示
                                        return h('img',  {
                                            attrs: {
                                                src: img,
                                                style: 'width: 30px;height: 30px;cursor:pointer'
                                            },
                                            on:{
                                                click:()=>{
                                                    this.$Modal.info({
                                                        title: '预览',
                                                        width:'800px',
                                                        content: '<a target="_blank" href="'+img+'" ><img style="width:100%;hieght:1005" src="'+img+'" /></a>'

                                                    })
                                                }
                                            }
                                        },);
                                    })
                                )
                            }else{
                                return h("span", '');
                            }

                        }
                    },{
                        title: '备注',
                        align:'center',
                        key: 'note',
                        width:'200',
                        render: (h, params) => {
                            return h('Input',{
                                props: {
                                    value:params.row.note,
                                    type:'textarea'
                                }
                            })
                        }
                    },{
                        title: '负责人员',
                        align:'center',
                        key: 'responsible_name'
                    },{
                        title: '操作',
                        align:'center',
                        key: 'id',
                        fixed: 'right',
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF', display:'inline-block !important'},
                                    on: {
                                        click: () => {
                                            this.show_edit_follow(params)
                                        }
                                    }
                                }, '编辑'),
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#ff0000', display:'inline-block !important'},
                                    on: {
                                        click: () => {
                                            this.del_follow(params)
                                        }
                                    }
                                }, '删除')
                            ]);

                        }

                    }],
                data:[]
            },
            table:{
                loading:false,
                current:1,
                total:0,
                limit:30,
                columns: [
                    {
                        title: '单号',
                        width:'100',
                        align:'center',
                        key: 'id'
                    },
                    {
                        title: '客户',
                        align:'center',
                        width:'200',
                        key: 'name',
                        render: (h, params) => {
                            let male = require("../../assets/11.png");
                            let female = require("../../assets/12.png");
                            let default_img = require("../../assets/3.png");
                            if (params.row.avatar != null && params.row.avatar != "") {
                                default_img = params.row.avatar
                            }
                            let default_ = female;
                            if (params.row.gender == 1) {
                                default_ = male;
                            }
                            let style =  params.row.is_locaking == 1 ? "style='color:red'" :""
                            if (params.row.is_big == 1) {
                                var default_big = require("@/assets/is_big.png");
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="display: flex;padding:10px 0 5px;height: 100px;cursor:pointer">`+
                                                `<img src=`+default_img+` style="width:50px;height:50px;">` +
                                                `<div style="margin-left:10px;flex:1;text-align: left;">` +
                                                    `<div `+style+` >`+(params.row.remark || params.row.customer_name)+`</div>`+
                                                    `<div><img src=`+default_+` style="width:20px;height:20px;"><img src=`+default_big+` style="width:32px;height:10.5px;">`+`</div>`+
                                                `</div>` +
                                            `</div>`
                                },
                                on:{
                                    click:()=>{
                                       copyText(params.row.remark || params.row.customer_name)
                                    }
                                }
                            })

                        }
                    },
                    {
                        title: '标签',
                        align:'center',
                        key: 'id',
                        width:200,
                        render: (h, params) => {
                            let tpl = "", tag_name = params.row.tag_name;
                            if (tag_name && tag_name.length > 0) {
                                for(let i in tag_name) {
                                    tpl += `<div><div  class="tag-class">`+tag_name[i]+`</div></div>`;
                                }
                            } else {
                                tpl += `<div class="tag-dotted">尚未设置</div>`;
                            }
                            return h("div", {
                                domProps:{
                                    innerHTML:`<div style="display:flex;flex-wrap:wrap;padding:10px 0 5px">`+
                                        tpl +
                                        `</div>`
                                },
                                on: {
                                    click: () => {
                                        this.customer_id = params.row.customerId;
                                        this.tags_active = params.row.tags_active;
                                        this.tags_return = false;
                                        this.show_label = true
                                    }
                                }
                            })

                        }
                    },{
                        title: '报价',
                        align:'center',
                        key: 'id',
                        width:120,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            this.customer_price.id = params.row.id
                                            this.customer_price.price = params.row.customer_price ?  params.row.customer_price : ""
                                            this.show_price= true;
                                        }
                                    }
                                }, params.row.customer_price ?  params.row.customer_price : "暂无报价")
                            ]);

                        }
                    },{
                        title: '场景目的',
                        align:'center',
                        key: 'id',
                        width:200,
                        render: (h, params) => {
                            return h('div', [
                                h('Input',{
                                    props: {
                                        value:params.row.customer_funs_text,
                                        type:'textarea',
                                        size:'small'
                                    },
                                    on: {
                                        input: (value) => {
                                            this.customer_function.text = value;
                                        }
                                    }
                                }), h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style:{color:'#3F8CFF','margin-top':'5px'},
                                        on: {
                                            click: () => {
                                                this.customer_function.type = 1 
                                                this.customer_function.id = params.row.id 
                                                this.sureCustomerFunction();
                                            }
                                        }
                                    },  "确认修改")
                            ]);
                        }
                    },{
                        title: '跟进状态',
                        align:'center',
                        key: 'id',
                        width:120,
                        render: (h, params) => {
                            let status_name = params.row.followStatus == 1 ? "首次跟进" :  params.row.followStatus == 0 ? '尚未跟进':`第`+params.row.followStatus+`次跟进`;
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small',
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            // if (params.row.name == "" || params.row == null) {
                                            //     this.$Message.error("用户必填信息：姓名为空。无法填写跟进信息");return;
                                            // }
                                            // if (params.row.phone == "" || params.row.phone == null) {
                                            //     this.$Message.error("用户必填信息：手机号为空。无法填写跟进信息");return;
                                            // }
                                            // if (params.row.wechat_number == "" ||params.row.wechat_number == null) {
                                            //     this.$Message.error("用户必填信息：微信号为空。无法填写跟进信息");return;
                                            // }

                                            this.order_id = params.row.id;
                                            this.formSuccess.order_id = this.order_id;
                                            this.show_follow = true;
                                            this.record_list();
                                        }
                                    }
                                }, status_name)
                            ]);

                        }
                    },{
                        title: '需求时间',
                        align:'center',
                        key: 'id',
                        width:120,
                        render: (h, params) => {
                            return h('div', [
                                h('Input',{
                                    props: {
                                        value:params.row.customer_funs_time,
                                        type:'textarea',
                                        size:'small'
                                    },
                                    on: {
                                        input: (value) => {
                                            this.customer_function.customer_time = value;
                                        }
                                    }
                                }), h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style:{color:'#3F8CFF','margin-top':'5px'},
                                        on: {
                                            click: () => {
                                            this.customer_function.type = 3 
                                            this.customer_function.id = params.row.id 
                                                this.sureCustomerFunction();
                                            }
                                        }
                                    },  "确认修改")
                            ]);
                            // return h('div', [
                            //     h('Button', {
                            //         props: {
                            //             type: 'text',
                            //             size: 'small',
                            //         },
                            //         style:{color:'#3F8CFF'},
                            //         on: {
                            //             click: () => {
                            //                 this.customer_function.type = 3 
                            //                 this.customer_function.id = params.row.id 
                            //                 this.show_time= true;
                            //             }
                            //         }
                            //     }, params.row.customer_funs_time ?  params.row.customer_funs_time : "暂无")
                            // ]);
                        }
                    },{
                        title: '客户电话',
                        align:'center',
                        key: 'id',
                        width:120,
                        render: (h, params) => {
                            return h('div', [
                                h('Input',{
                                    props: {
                                        value:params.row.phone,
                                        type:'textarea',
                                        size:'small'
                                    },
                                    on: {
                                        input: (value) => {
                                            this.customer_function.phone = value;
                                            params.row.phone = value
                                        }
                                    }
                                }), h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                        },
                                        style:{color:'#3F8CFF','margin-top':'5px'},
                                        on: {
                                            click: () => {
                                                this.customer_function.customer_id = params.row.customerId
                                                this.customer_function.type = 2 
                                                this.customer_function.id = params.row.id 
                                                this.sureCustomerFunction();
                                            }
                                        }
                                    },  "确认修改")
                            ]);
                        }
                    },
                    {
                        title: '跟进员工',
                        align:'center',
                        key: 'id',
                        width:200,
                        render: (h, params) => {
                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    on: {
                                        click: () => {
                                            if (this.userInfo.user_id !=0) {
                                                return
                                            }
                                            this.order_id = params.row.id;
                                            this.department_member_id = params.row.department_member_id
                                            this.show_member = true
                                        }
                                    }
                                }, params.row.department_member_name)
                            ]);

                        }
                    },
                    {
                        title: '操作时间',
                        align:'center',
                        width:180,
                        key: 'utime'
                    },
                    {
                        title: '添加时间',
                        align:'center',
                        width:180,
                        key: 'ctime'
                    },
                    {
                        title: '行业',
                        align:'center',
                        width:120,
                        key: 'industry_name',
                        render: (h, params) => {
                            let industry_name = params.row.industryName ? params.row.industryName : "暂未设置"

                            return h('div', [
                                h('Button', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#3F8CFF'},
                                    on: {
                                        click: () => {
                                            this.order_id = params.row.id;
                                            this.industry_id = params.row.industryId;
                                            this.show_industry = true;
                                        }
                                    }
                                }, industry_name)
                            ]);

                        }
                    },
                    {
                        title: '操作',
                        align:'center',
                        key: 'id',
                        fixed: 'right',
                        width:200,
                        render: (h, params) => {
                            let btnArr = []
                            let successbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.customer_name = (params.row.remark && params.row.remark !=  null ) ? params.row.remark : params.row.customer_name ;
                                        this.successSubmit = {
                                            id:this.order_id,
                                            duesoon_type:'1',
                                            qq_group:"",
                                            money:"",
                                            pay_time:this.current_date,
                                            order_number:'',
                                            transaction_type_id:"",
                                            aftersale_id:"",
                                            service_requirements:"",
                                            expiration_date:"",
                                            servicecharge:"",
                                            customer_source_id:"",
                                            is_two_sale:"0",
                                            name:params.row.customer_name,
                                            remark:params.row.remark,
                                            phone:params.row.phone,
                                            wechat_number:params.row.wechat_number,
                                            wangwang_number:params.row.wangwang_number,
                                            city_number:params.row.city_number,
                                            city_name:params.row.city_name,
                                            detailed_address:params.row.detailed_address,
                                            latlng: params.row.latlng,
                                            is_big: params.row.is_big + "",
                                        }
                                        this.show_success = true;
                                    }
                                }
                            }, '成交')
                            let locakingbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.locking()
                                    }
                                }
                            }, '锁定')
                            let infobtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#3F8CFF'},
                                on: {
                                    click: () => {
                                        this.$router.push({
                                            path: '/customerpool/info',
                                            query: {
                                                order_id: params.row.id,
                                                customer_id:params.row.customerId,
                                                type:2
                                            }
                                        });
                                    }
                                }
                            }, '详情')
                            let lookbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:params.row.is_topping == 0 ? '#3F8CFF' : '#ff9800'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.topping(params.row.is_topping)
                                    }
                                }
                            }, params.row.is_topping == 0 ? '置顶' : '取消置顶')

                            let release_btn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                style:{color:'#ff0000'},
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.show_release = true
                                    }
                                }
                            }, '释放')

                            let delbtn = h('Button', {
                                props: {
                                    type: 'text',
                                    size: 'small'
                                },
                                on: {
                                    click: () => {
                                        this.order_id = params.row.id;
                                        this.delete_order()
                                    }
                                }
                            }, '删除')

                            let lastbtn = h('div', {
                                    props: {
                                        type: 'text',
                                        size: 'small'
                                    },
                                    style:{color:'#ff0000'},
                                }, params.row.days+"天后自动释放")
                            btnArr.push(infobtn)
                            btnArr.push(successbtn)
                            if (params.row.is_locaking == 0) {
                                btnArr.push(locakingbtn)
                            }

                            btnArr.push(lookbtn)
                            btnArr.push(release_btn)
                            btnArr.push(delbtn)
                            if (params.row.is_locaking == 0) {
                                btnArr.push(lastbtn)
                            }

                            return h('div', btnArr);

                        }

                    }
                ],
                data: [],
                default_cid:0,
                search_customer:""
            }

        }
    },
    mounted(){
        this.userInfo = this.$store.state.userInfo
        this.getList();
        this.get_industry();
        this.get_customer_department_member();
    },
    methods:{
        searchList(){
            this.table.current = 1
            this.getList();
        },
        show_customer_fun(){
            this.show_customer = true
        },
        filter_customer(e){
            this.search_customer = e;
            this.get_customer_list();
        },
        del_follow(e){
            this.$Modal.confirm({
                title: '提示',
                content: '<p>是否删除跟进记录？</p>',
                onOk: () => {
                    follow_del({id:e.row.id, order_id:this.formSuccess.order_id}).then(res=>{
                        if (res.code == 200) {
                            this.record_list()
                            this.getList()
                            this.$Message.success(res.msg);
                        } else {
                            this.$Message.error(res.msg)
                        }
                    })
                }
            });

        },
        add_follow_fun(){
            this.formSuccess ={
                order_id: this.formSuccess.order_id,
                follow_img:[],
                note:""
            };
            this.show_add_follow = true;
        },
        show_edit_follow(params){
            this.formSuccess.note = params.row.note;
            this.formSuccess.id = params.row.id;
            this.default_follow_img = [];
            this.formSuccess.follow_img = [];
            for(let i in params.row.follow_img) {
                this.formSuccess.follow_img.push(params.row.follow_img[i].id)
                this.default_follow_img.push({id:params.row.follow_img[i].id, name:params.row.follow_img[i].url, url:params.row.follow_img[i].url})
            }
            this.show_add_follow = true;
        },
        handleSuccess(e){
            if (e.code == 200)  {
                this.formSuccess.follow_img.push(e.data.id)
            }
        },
        handlePreview(e){
            let img = "";
            if (e.response != undefined){
                img = e.response.data.url
            } else {
                img = e.url
            }
            this.$Modal.info({
                title: '预览',
                width:'800px',
                content: '<a target="_blank" href="'+img+'" ><img style="width:100%;hieght:1005" src="'+img+'" /></a>'

            })
        },
        handleRemove(e){

            let id = 0, that = this;
            if (e.response != undefined){
                id = e.response.data.id
            } else {
                id = e.id
            }
            this.formSuccess.follow_img.forEach(function(item, index){
                if (item == id) {
                    that.formSuccess.follow_img.splice(index, 1)
                }
            })
            del_img({id:id, follow_id:this.formSuccess.id}).then(res=>{
                if (res.code == 400) {
                    this.$Message.error(res.msg);
                } else {
                    this.$Message.success(res.msg);
                }
            })
        },
        getList(){
            let val = {limit:this.table.limit, page:this.table.current};
            if(this.search_name != "") {
                val.search_name = this.search_name
            }
            if(this.search_sale_id != "") {
                val.search_sale_id = this.search_sale_id
            }
            if (this.screen_tags_text != "")  {
                val.screen_tags_text = this.screen_tags_text
            }
            val.screen_tags_active_id = this.screen_tags_active_id
            this.table.loading = true;
            order_list(val).then(res=>{
                this.table.loading = false;
                if(res.code == 200) {
                    this.table.data = res.data;
                    this.table.total = res.total;
                } else {
                    this.table.data = [];
                    this.table.total = 0;
                    this.$Message.error(res.msg);
                }
            })
        },
        changepage(e){
            this.table.current = e;
            this.getList();
        },
        get_industry(){
            customer_industry_list().then(res=>{
                this.industry_list = res.data
            })
        },
        // 获取部门员工
        get_customer_department_member(){
            customer_department_member().then(res=>{
                this.department_member_list = res.data
            })
        },
        // 修改顾客行业
        set_customer_industry(){
            set_customer_industry({id:this.order_id, industry_id:this.industry_id}).then(res=>{
                if(res.code == 200) {
                    this.getList();
                    this.show_industry = false;
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        //修改跟进的员工
        set_customer_staff(){
            set_customer_staff({id:this.order_id, department_member_id:this.department_member_id}).then(res=>{
                if(res.code == 200) {
                    this.show_member = false;
                    this.getList();
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        // 释放订单
        relex_order(){
            release_order({order_id:this.order_id}).then(res=>{
                if(res.code == 200) {
                    this.getList();
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        //下单
        add_order(){

            if (this.order_customer_id == "") {
                this.$Message.error("请选择客户");return;
            }
            add_order({customer_id:this.order_customer_id}).then(res=>{
                if(res.code == 200) {
                    this.show_customer = false;
                    this.getList();
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        // 获取客户列表
        get_customer_list(){
            this.customer_loading = true
            get_customer_list({search_customer:this.search_customer}).then(res=>{
                this.customer_loading = false
                if(res.code == 200) {
                    this.order_customer_list = res.data
                    console.log(this.default_cid)
                    if (this.default_cid !=0 && this.default_cid != undefined) {
                        // this.order_customer_id = this.default_cid
                    }
                }
            })
        },
        // 同步客户订单
        sync_customer(){
            this.$Notice.info({
                title: '客户数据同步中',
            });
            sync_customer().then(res=>{
                this.$Notice.destroy()
                if (res.code == 200) {
                    this.table.current = 1
                    this.getList();
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        // 查询跟进记录
        record_list(){

            this.follow_table.loading = true;
            follow_record_list({order_id:this.order_id, limit:this.follow_table.limit, page:this.follow_table.current}).then(res=>{
                this.follow_table.loading = false;
                if (res.code == 200) {
                    this.follow_table.data = res.data;
                    this.follow_table.total = res.total;
                } else {
                    this.follow_table.data = [];
                    this.follow_table.total = 0;
                    this.$Message.error(res.msg);
                }
            })
        },
        // 跟进记录换页
        change_record(e){
            this.follow_table.current = e;
            this.record_list();
        },
        edit_follow(){
            if (this.formSuccess.note == "" ||  this.formSuccess.note == null) {
                this.$Message.error("请填写跟进情况");return;
            }
            if (this.formSuccess.follow_img.length > 0) {
                this.formSuccess.follow_img = this.formSuccess.follow_img.join(",")
            }
            this.$Message.info({
                content: '提交中',
                duration: 0
            });
            follow_edit(this.formSuccess).then(res=>{
                this.$Message.destroy()
                if (res.code == 200) {
                    this.show_add_follow = false;
                    this.record_list();
                    this.getList();
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },


        send_notice(data){
            let datas = JSON.parse(data.list)
            let msg = "";
            for(var i in datas) {
                msg = "与单号："+datas[i].id+"相同客户的订单, 已被《"+data.name+"》成功交付,请及时检查您的订单"
                WebSocket.sendMsg( JSON.stringify({ 'type': 2, 'to': datas[i].department_member_id, 'data':msg }))
            }

        },
        add_customer(){
            this.show_infos = true
            this.submitInfo = {
                gender: "",
                name : "",
                birthday: "",
                phone: "",
                wechat_number: "",
                wangwang_number: "",
                email: "",
                company_name: "",
                detailed_address: "",
                city_name :"",
                city_number :[]
            };
        },
        save_custmer(){
            if (this.submitInfo.name == "") {
                this.$Message.error("用户姓名不能为空");return;
            }
            save_customer_info(this.submitInfo).then(res=>{
                if (res.code == 200) {
                    if(res.data != 0) {
                        this.default_cid = res.data
                    }
                    this.search_customer = this.submitInfo.name
                    this.get_customer_list()
                    this.show_infos = false
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        delete_order(){
            this.$Modal.confirm({
                title: '提示',
                content: '<p>是否删除该订单？</p>',
                onOk: () => {
                    order_delete({order_id:this.order_id}).then(res=>{
                        if (res.code == 200) {
                            this.getList()
                            this.$Message.success(res.msg);
                        } else {
                            this.$Message.error(res.msg)
                        }
                    })
                }
            });
        },
        
        select_city(e){
            this.submitInfo.city_name = e.city_name
            this.submitInfo.city_number = e.city_number
        },
        locking(){

            this.$Modal.confirm({
                title: '提示',
                content: '<p>是否锁定订单？</p>',
                onOk: () => {
                    order_locaking({order_id:this.order_id}).then(res=>{
                        if (res.code == 200) {
                            this.getList()
                            this.$Message.success(res.msg);
                        } else {
                            this.$Message.error(res.msg)
                        }
                    })
                }
            });
        },
        topping(e){
            let [str, is_topping ] = ["是否置顶订单", 1]
            if (e == 1) {
                is_topping = 0
                str = "是否取消置顶"
            }
            this.$Modal.confirm({
                title: '提示',
                content: '<p>'+str+'？</p>',
                onOk: () => {
                    order_topping({order_id:this.order_id, type:1,is_topping:is_topping}).then(res=>{
                        if (res.code == 200) {
                            this.getList()
                            this.$Message.success(res.msg);
                        } else {
                            this.$Message.error(res.msg)
                        }
                    })
                }
            });

        },
        hide_label_func(e){
            this.show_label = false
            if (e == 1) {
                this.getList()
            }
        },
        screenTags(){
            this.tags_return = true;
            this.show_label = true
            if (this.screen_tags_text != "'") {
                this.tags_active = this.screen_tags_active
            }
        },
        get_select_tags(e){
            this.show_label = false;
            this.screen_tags_list = e;
            this.screen_tags_active = ""
            this.screen_tags_active_id = ""
            this.screen_tags_text = ""
            if (this.screen_tags_list) {
                this.tags_active = [];
                let screen_tags = [];
                let screen_tags_active_id = [];
                for(let i in this.screen_tags_list) {
                    this.tags_active.push(this.screen_tags_list[i].tag_id+"，"+this.screen_tags_list[i].tag_name)
                    screen_tags.push(this.screen_tags_list[i].tag_name)
                    screen_tags_active_id.push(this.screen_tags_list[i].tag_id)
                }
                this.screen_tags_active = this.tags_active
                this.screen_tags_text = screen_tags.join(",")
                this.screen_tags_active_id = screen_tags_active_id.join(",")
            }
        },
        cleanTags(){
            this.screen_tags_active = []
            this.screen_tags_text = ""
            this.screen_tags_active_id = "";
        },
        orderSubmitSuccess(){
            this.$Message.info({
                content: '提交中，请等待',
                duration: 0
            });
            order_success(this.successSubmit).then(res=>{
                this.$Message.destroy()
                if (res.code == 200) {
                    this.show_success = false
                    this.$Message.success(res.msg);
                    this.getList();
                } else {
                    this.$Message.error(res.msg);
                }
                this.$refs.deal_child.is_submit = 0;
            })
        },
        surePrice(){
            if (isNaN(this.customer_price.price)) {
                this.$Message.error("请填写金额");return;
            }
            this.$Message.info({
                content: '提交中，请等待',
                duration: 0
            });
            customerPrice(this.customer_price).then(res=>{
                this.$Message.destroy()
                if (res.code == 200) {
                    this.show_price = false
                    this.$Message.success(res.msg);
                    this.getList();
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        sureCustomerFunction(){
            if ( this.customer_function.type == 1 && !this.customer_function.text) {
                this.$Message.error("请填写大概功能");return;
            }
            if ( this.customer_function.type == 2 && !this.customer_function.phone) {
                this.$Message.error("请填写客户电话");return;
            }
            if ( this.customer_function.type == 3 && !this.customer_function.customer_time) {
                this.$Message.error("请选择时间");return;
            }

            this.$Message.info({
                content: '提交中，请等待',
                duration: 0
            });
            customerFunction(this.customer_function).then(res=>{
                this.$Message.destroy()
                if (res.code == 200) {
                    if (this.customer_function.type == 1)this.customer_function.text = ""
                    if (this.customer_function.type == 2) this.customer_function.phone = ""
                    if (this.customer_function.type == 3)this.customer_function.customer_time = ""
                    this.$Message.success(res.msg);
                } else {
                    this.$Message.error(res.msg);
                }
            })
        },
        
        // changeDate(e){
        //         this.customer_function.customer_time = e;
        // },
        // sureTime(){
        //     if (!this.customer_function.customer_time) {
        //         this.$Message.error("请选择时间");return;
        //     }
        //     this.$Message.info({
        //         content: '提交中，请等待',
        //         duration: 0
        //     });
        //     customerFunction(this.customer_function).then(res=>{
        //         this.$Message.destroy()
        //         if (res.code == 200) {
        //             this.customer_function.customer_time = "";
        //             this.show_time = false
        //             this.getList();
        //             this.$Message.success(res.msg);
        //         } else {
        //             this.$Message.error(res.msg);
        //         }
        //     })
        // }

    }
}
</script>
<style scoped>

    >>>.tag-class{
        width: 90%;
        padding:5px 10px;
        border:1px solid #ddd;
        border-radius: 5px;
        margin:2px 5px;
        background: #ffffff;
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        cursor: pointer;
    }
    >>>.tag-dotted{

        width: 90%;
        padding:5px 10px;
        border:1px dotted #ddd;
        border-radius: 5px;
        margin:2px 5px;
        cursor: pointer;
    }

    >>> #add_customer .ivu-select-dropdown-list .ivu-select-item{
        height:50px
    }
    >>>.screen-tags{
        border:1px solid #dcdee2;
        width:240px; height:30px;
        display:inline-block;
        position: relative;
        vertical-align: middle;
        line-height: normal;
        border-radius: 4px;
        margin-left:10px;
        padding:4px;
        cursor: pointer;
        color:#c8ccd5;
    }
    >>>.screen-tags-text{
        overflow:hidden;
        text-overflow:ellipsis;
        white-space:nowrap;
        color:#000000;
        width:235px;
    }
    >>>.screen-tags-icon{
        position: absolute;
        top: -11px;right: 1px;
        color: #3F8CFF;
    }
    >>>.screen-tags-icon:hover{
        color:#0c4cad
    }
    >>>.ivu-modal .ivu-picker-confirm .ivu-btn-text{
        display: block;
    }
</style>
